<app-message></app-message>
<div class="login">
	<div class="login-box">
		<form (ngSubmit)="reset()" id="monitor-resetPassWord"
			[formGroup]="changePassWordform">
			<h5 class="text-blue">Update Your
				Password</h5>
			<p class="text-white-50">Please
				enter your new password below
			</p>
			<div class="form-group">
				<div
					class="form-group inner-addon right-addon">
					<div class="input-group">
						<input name="monitor_password"
							[type]="showPassword ? 'text' : 'password'"
							formControlName="password"
							class="form-control pwd-control"
							id="monitor_password-field"
							placeholder="Password"
							autocomplete="new-password">
						<div>
							<i alt="show"
								class="fa far fa-eye eye-show"
								(click)="showPassword = !showPassword"
								[class.hide]="showPassword"></i>
							<i alt="hide"
								class="fa far fa-eye-slash eye-hide"
								(click)="showPassword = !showPassword"
								[class.hide]="!showPassword"></i>
						</div>
					</div>
				</div>
			</div>
			<div class="form-group">
				<div
					class="form-group inner-addon right-addon">
					<div class="input-group">
						<input name="monitor_password"
							[type]="showPassword2 ? 'text' : 'password'"
							formControlName="passwordRepeat"
							class="form-control pwd-control"
							id="monitor_password-field"
							placeholder="Repeat Password"
							autocomplete="new-password">
						<div>
							<i alt="show"
								class="fa far fa-eye eye-show"
								(click)="showPassword2 = !showPassword2"
								[class.hide]="showPassword2"></i>
							<i alt="hide"
								class="fa far fa-eye-slash eye-hide"
								(click)="showPassword2 = !showPassword2"
								[class.hide]="!showPassword2"></i>
						</div>
					</div>
				</div>
			</div>
			<button
				class="btn btn-lg btn-primary btn-block"
				type="submit">Reset
				Password</button>
		</form>
		<span class="float-right">
			<a class="btn btn-primary btn-md"
				style="margin-top:10px"
				href="/login">Back</a>
		</span>

	</div>
</div>
